import { type JSX, type ParentProps } from 'solid-js';
import { InfoButton } from './InfoButton';
import './InfoBox.css';

export interface InfoBoxProps {
  infoKey: string;
  infoContent?: string;
  resetId?: string;
  onReset?: () => void;
}

export function InfoBox(props: ParentProps<InfoBoxProps>): JSX.Element {
  return (
    <div class="info-box">
      <InfoButton infoKey={props.infoKey} content={props.infoContent} />
      <div class="info-box-content">
        {props.children}
      </div>
      {props.resetId && (
        <button class="slider-reset icon-btn icon-md" id={props.resetId} onClick={() => props.onReset?.()}>
          <i data-lucide="rotate-cw" />
        </button>
      )}
    </div>
  );
}
